/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FilterOptionsList,
  MessageResponse,
  ModelCreateInput,
  ModelExtended,
  ModelUpdateInput,
  Models,
  ModelsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Model
 */
export const createModel = (
    modelCreateInput: MaybeRefOrGetter<ModelCreateInput>,
 signal?: AbortSignal
) => {
      modelCreateInput = toValue(modelCreateInput);

      return axiosClient<ModelExtended>(
      {url: `/models`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelCreateInput, signal
    },
      );
    }




export const getCreateModelMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModel>>, TError,CreateModelMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createModel>>, TError,CreateModelMutationVariables, TContext> => {

const mutationKey = ['createModel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModel>>, CreateModelMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createModel(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateModelMutationResult = NonNullable<Awaited<ReturnType<typeof createModel>>>
    export type CreateModelMutationBody = ModelCreateInput
    export type CreateModelMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateModelMutationVariables = {data: ModelCreateInput}

    /**
 * @summary Create Model
 */
export const useCreateModel = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModel>>, TError,CreateModelMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createModel>>,
        TError,
        CreateModelMutationVariables,
        TContext
      > => {
      return useMutation(getCreateModelMutationOptions(options), queryClient);
    }
    /**
 * @summary Models list
 */
export const models = (
    params?: MaybeRefOrGetter<ModelsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Models>(
      {url: `/models`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelsQueryKey = (params?: MaybeRefOrGetter<ModelsParams>,) => {
    return [
    'models', ...(params ? [params] : [])
    ] as const;
    }


export const getModelsQueryOptions = <TData = Awaited<ReturnType<typeof models>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ModelsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof models>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof models>>> = ({ signal }) => models(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof models>>, TError, TData>
}

export type ModelsQueryResult = NonNullable<Awaited<ReturnType<typeof models>>>
export type ModelsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Models list
 */

export function useModels<TData = Awaited<ReturnType<typeof models>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ModelsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof models>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Production states
 */
export const modelProductionStates = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/models/production-states`, method: 'GET', signal
    },
      );
    }




export const getModelProductionStatesQueryKey = () => {
    return [
    'models','production-states'
    ] as const;
    }


export const getModelProductionStatesQueryOptions = <TData = Awaited<ReturnType<typeof modelProductionStates>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelProductionStates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelProductionStatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelProductionStates>>> = ({ signal }) => modelProductionStates(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelProductionStates>>, TError, TData>
}

export type ModelProductionStatesQueryResult = NonNullable<Awaited<ReturnType<typeof modelProductionStates>>>
export type ModelProductionStatesQueryError = ErrorType<StandardError>


/**
 * @summary Model Production states
 */

export function useModelProductionStates<TData = Awaited<ReturnType<typeof modelProductionStates>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelProductionStates>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelProductionStatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Reload Loaners
 */
export const reloadLoaners = (

 signal?: AbortSignal
) => {


      return axiosClient<MessageResponse>(
      {url: `/models/reload-loaners`, method: 'PUT', signal
    },
      );
    }




export const getReloadLoanersMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadLoaners>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reloadLoaners>>, TError,void, TContext> => {

const mutationKey = ['reloadLoaners'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reloadLoaners>>, void> = () => {


          return  reloadLoaners()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReloadLoanersMutationResult = NonNullable<Awaited<ReturnType<typeof reloadLoaners>>>

    export type ReloadLoanersMutationError = ErrorType<StandardError>


    /**
 * @summary Reload Loaners
 */
export const useReloadLoaners = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadLoaners>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reloadLoaners>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReloadLoanersMutationOptions(options), queryClient);
    }
    /**
 * @summary Reload Models Matrix
 */
export const reloadModelsMatrix = (

 signal?: AbortSignal
) => {


      return axiosClient<MessageResponse>(
      {url: `/models/reload-matrix`, method: 'PUT', signal
    },
      );
    }




export const getReloadModelsMatrixMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadModelsMatrix>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reloadModelsMatrix>>, TError,void, TContext> => {

const mutationKey = ['reloadModelsMatrix'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reloadModelsMatrix>>, void> = () => {


          return  reloadModelsMatrix()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReloadModelsMatrixMutationResult = NonNullable<Awaited<ReturnType<typeof reloadModelsMatrix>>>

    export type ReloadModelsMatrixMutationError = ErrorType<StandardError>


    /**
 * @summary Reload Models Matrix
 */
export const useReloadModelsMatrix = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadModelsMatrix>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reloadModelsMatrix>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReloadModelsMatrixMutationOptions(options), queryClient);
    }
    /**
 * @summary Reload Modules
 */
export const reloadModules = (

 signal?: AbortSignal
) => {


      return axiosClient<MessageResponse>(
      {url: `/models/reload-modules`, method: 'PUT', signal
    },
      );
    }




export const getReloadModulesMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadModules>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reloadModules>>, TError,void, TContext> => {

const mutationKey = ['reloadModules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reloadModules>>, void> = () => {


          return  reloadModules()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReloadModulesMutationResult = NonNullable<Awaited<ReturnType<typeof reloadModules>>>

    export type ReloadModulesMutationError = ErrorType<StandardError>


    /**
 * @summary Reload Modules
 */
export const useReloadModules = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadModules>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reloadModules>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReloadModulesMutationOptions(options), queryClient);
    }
    /**
 * @summary Reload Paints
 */
export const reloadPaints = (

 signal?: AbortSignal
) => {


      return axiosClient<MessageResponse>(
      {url: `/models/reload-paints`, method: 'PUT', signal
    },
      );
    }




export const getReloadPaintsMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadPaints>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reloadPaints>>, TError,void, TContext> => {

const mutationKey = ['reloadPaints'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reloadPaints>>, void> = () => {


          return  reloadPaints()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReloadPaintsMutationResult = NonNullable<Awaited<ReturnType<typeof reloadPaints>>>

    export type ReloadPaintsMutationError = ErrorType<StandardError>


    /**
 * @summary Reload Paints
 */
export const useReloadPaints = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadPaints>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reloadPaints>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReloadPaintsMutationOptions(options), queryClient);
    }
    /**
 * @summary Reload Models SC Data
 */
export const reloadModelsScData = (

 signal?: AbortSignal
) => {


      return axiosClient<MessageResponse>(
      {url: `/models/reload-scdata`, method: 'PUT', signal
    },
      );
    }




export const getReloadModelsScDataMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadModelsScData>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reloadModelsScData>>, TError,void, TContext> => {

const mutationKey = ['reloadModelsScData'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reloadModelsScData>>, void> = () => {


          return  reloadModelsScData()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReloadModelsScDataMutationResult = NonNullable<Awaited<ReturnType<typeof reloadModelsScData>>>

    export type ReloadModelsScDataMutationError = ErrorType<StandardError>


    /**
 * @summary Reload Models SC Data
 */
export const useReloadModelsScData = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadModelsScData>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reloadModelsScData>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReloadModelsScDataMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Model
 */
export const destroyModel = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelExtended>(
      {url: `/models/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyModelMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModel>>, TError,DestroyModelMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyModel>>, TError,DestroyModelMutationVariables, TContext> => {

const mutationKey = ['destroyModel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyModel>>, DestroyModelMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyModel(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyModelMutationResult = NonNullable<Awaited<ReturnType<typeof destroyModel>>>

    export type DestroyModelMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyModelMutationVariables = {id: string}

    /**
 * @summary Destroy Model
 */
export const useDestroyModel = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModel>>, TError,DestroyModelMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyModel>>,
        TError,
        DestroyModelMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyModelMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Detail
 */
export const model = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelExtended>(
      {url: `/models/${id}`, method: 'GET', signal
    },
      );
    }




export const getModelQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'models',id
    ] as const;
    }


export const getModelQueryOptions = <TData = Awaited<ReturnType<typeof model>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof model>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof model>>> = ({ signal }) => model(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof model>>, TError, TData>
}

export type ModelQueryResult = NonNullable<Awaited<ReturnType<typeof model>>>
export type ModelQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Detail
 */

export function useModel<TData = Awaited<ReturnType<typeof model>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof model>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Model
 */
export const updateModel = (
    id: MaybeRefOrGetter<string>,
    modelUpdateInput: MaybeRefOrGetter<ModelUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelUpdateInput = toValue(modelUpdateInput);

      return axiosClient<ModelExtended>(
      {url: `/models/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelUpdateInput, signal
    },
      );
    }




export const getUpdateModelMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModel>>, TError,UpdateModelMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateModel>>, TError,UpdateModelMutationVariables, TContext> => {

const mutationKey = ['updateModel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModel>>, UpdateModelMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateModel(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelMutationResult = NonNullable<Awaited<ReturnType<typeof updateModel>>>
    export type UpdateModelMutationBody = ModelUpdateInput
    export type UpdateModelMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateModelMutationVariables = {id: string;data: ModelUpdateInput}

    /**
 * @summary Update Model
 */
export const useUpdateModel = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModel>>, TError,UpdateModelMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateModel>>,
        TError,
        UpdateModelMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateModelMutationOptions(options), queryClient);
    }
    /**
 * @summary Reload Single Model
 */
export const reloadOneModel = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<MessageResponse>(
      {url: `/models/${id}/reload-one`, method: 'PUT', signal
    },
      );
    }




export const getReloadOneModelMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadOneModel>>, TError,ReloadOneModelMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reloadOneModel>>, TError,ReloadOneModelMutationVariables, TContext> => {

const mutationKey = ['reloadOneModel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reloadOneModel>>, ReloadOneModelMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  reloadOneModel(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReloadOneModelMutationResult = NonNullable<Awaited<ReturnType<typeof reloadOneModel>>>

    export type ReloadOneModelMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ReloadOneModelMutationVariables = {id: string}

    /**
 * @summary Reload Single Model
 */
export const useReloadOneModel = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadOneModel>>, TError,ReloadOneModelMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reloadOneModel>>,
        TError,
        ReloadOneModelMutationVariables,
        TContext
      > => {
      return useMutation(getReloadOneModelMutationOptions(options), queryClient);
    }
    /**
 * @summary Reload Single Model Matrix
 */
export const reloadOneModelMatrix = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<MessageResponse>(
      {url: `/models/${id}/reload-one-matrix`, method: 'PUT', signal
    },
      );
    }




export const getReloadOneModelMatrixMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadOneModelMatrix>>, TError,ReloadOneModelMatrixMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reloadOneModelMatrix>>, TError,ReloadOneModelMatrixMutationVariables, TContext> => {

const mutationKey = ['reloadOneModelMatrix'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reloadOneModelMatrix>>, ReloadOneModelMatrixMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  reloadOneModelMatrix(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReloadOneModelMatrixMutationResult = NonNullable<Awaited<ReturnType<typeof reloadOneModelMatrix>>>

    export type ReloadOneModelMatrixMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ReloadOneModelMatrixMutationVariables = {id: string}

    /**
 * @summary Reload Single Model Matrix
 */
export const useReloadOneModelMatrix = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadOneModelMatrix>>, TError,ReloadOneModelMatrixMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reloadOneModelMatrix>>,
        TError,
        ReloadOneModelMatrixMutationVariables,
        TContext
      > => {
      return useMutation(getReloadOneModelMatrixMutationOptions(options), queryClient);
    }
    /**
 * @summary Reload Single Model Paints
 */
export const reloadOneModelPaints = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<MessageResponse>(
      {url: `/models/${id}/reload-one-paints`, method: 'PUT', signal
    },
      );
    }




export const getReloadOneModelPaintsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadOneModelPaints>>, TError,ReloadOneModelPaintsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reloadOneModelPaints>>, TError,ReloadOneModelPaintsMutationVariables, TContext> => {

const mutationKey = ['reloadOneModelPaints'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reloadOneModelPaints>>, ReloadOneModelPaintsMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  reloadOneModelPaints(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReloadOneModelPaintsMutationResult = NonNullable<Awaited<ReturnType<typeof reloadOneModelPaints>>>

    export type ReloadOneModelPaintsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ReloadOneModelPaintsMutationVariables = {id: string}

    /**
 * @summary Reload Single Model Paints
 */
export const useReloadOneModelPaints = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadOneModelPaints>>, TError,ReloadOneModelPaintsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reloadOneModelPaints>>,
        TError,
        ReloadOneModelPaintsMutationVariables,
        TContext
      > => {
      return useMutation(getReloadOneModelPaintsMutationOptions(options), queryClient);
    }
    /**
 * @summary Reload Single Model SC Data
 */
export const reloadOneModelScData = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<MessageResponse>(
      {url: `/models/${id}/reload-one-scdata`, method: 'PUT', signal
    },
      );
    }




export const getReloadOneModelScDataMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadOneModelScData>>, TError,ReloadOneModelScDataMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reloadOneModelScData>>, TError,ReloadOneModelScDataMutationVariables, TContext> => {

const mutationKey = ['reloadOneModelScData'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reloadOneModelScData>>, ReloadOneModelScDataMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  reloadOneModelScData(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReloadOneModelScDataMutationResult = NonNullable<Awaited<ReturnType<typeof reloadOneModelScData>>>

    export type ReloadOneModelScDataMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ReloadOneModelScDataMutationVariables = {id: string}

    /**
 * @summary Reload Single Model SC Data
 */
export const useReloadOneModelScData = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reloadOneModelScData>>, TError,ReloadOneModelScDataMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reloadOneModelScData>>,
        TError,
        ReloadOneModelScDataMutationVariables,
        TContext
      > => {
      return useMutation(getReloadOneModelScDataMutationOptions(options), queryClient);
    }
    /**
 * @summary Use RSI Image
 */
export const useRsiImage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelExtended>(
      {url: `/models/${id}/use-rsi-image`, method: 'PUT', signal
    },
      );
    }




export const getUseRsiImageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof useRsiImage>>, TError,UseRsiImageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof useRsiImage>>, TError,UseRsiImageMutationVariables, TContext> => {

const mutationKey = ['useRsiImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof useRsiImage>>, UseRsiImageMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  useRsiImage(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UseRsiImageMutationResult = NonNullable<Awaited<ReturnType<typeof useRsiImage>>>

    export type UseRsiImageMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UseRsiImageMutationVariables = {id: string}

    /**
 * @summary Use RSI Image
 */
export const useUseRsiImage = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof useRsiImage>>, TError,UseRsiImageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof useRsiImage>>,
        TError,
        UseRsiImageMutationVariables,
        TContext
      > => {
      return useMutation(getUseRsiImageMutationOptions(options), queryClient);
    }
